<div (click)="primecapIconClick()" class="icon-inner {{iconsClass}}" [innerHTML]="svgContent | async"></div>